const dataSampleMessages = [
  'Selalu Berkarya!', 
  'Halo semuaaanyaa~', 
  ':)',
  '',
  'Yang semangat dong, yang semangat dong!',
  'Terus semangat, pantang menyerah, walaupun kita tahu dunia ini terkadang tidak adil',
];

export function makeDataSample(counter = null) {
  const isCollectionSample = counter !== null
  if (isCollectionSample) {
    return {
      supporter_name: "Supporter " + (counter + 1),
      quantity: (counter + 1),
      price: 5000 * (counter + 1),
      unit: "Cendol",
      supporter_message: dataSampleMessages[counter],
    };
  }
  else {
    const sampleMessageIndex = Math.floor(Math.random() * dataSampleMessages.length);
    const quantity = Math.floor(Math.random() * 10) + 1;

    return {
      supporter_name: "Seseorang",
      quantity: quantity,
      price: quantity * 5000,
      unit: "Cendol",
      supporter_message: dataSampleMessages[sampleMessageIndex],
      // supporter_message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent est augue, condimentum non diam in, congue maximus sem. Maecenas faucibus urna a porta fringilla.", 
    };
  }
}

export async function handlePreview(manager) {

  if (h.isTrue(manager.get('use_placeholder'))) {
    if (h.isTrue(manager.get('ef_initial_data'))) {

      for (var i = 0; i < dataSampleMessages.length; i++) {
        await manager.addEventFeed(makeDataSample(i));
      }
    }
    else {
      manager.addEventFeedEmpty("trakteer.id/mypageid");
    }
  }
  else {
    await manager.loadData();
  }
}
